import { useAppConfigSafe } from 'Components/utils/AppBootstrapper/AppConfigContext';
import useFeatureToggle from 'Hooks/useFeatureToggle';

const useIsLogTypeRBACEnabled = () => {
  const isAlertsRBACEnabled = useFeatureToggle('ENABLE_ALERT_RBAC_LOG_TYPES');
  const appConfig = useAppConfigSafe();
  return [appConfig?.enableDatalakeRbac, isAlertsRBACEnabled].some(Boolean);
};

export default useIsLogTypeRBACEnabled;
